export const environment = {
    name: 'server',
    production: false,
    baseUrl: '', 
};